module.exports = __webpack_public_path__ + "img/img_title_zhuti@2x.01afd08b.png";